/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { Text } from '@/shared/ui';
import {
  SALE_STATE_STYLES,
  useSaleStateLabel,
  type SaleState,
} from '../constants/sale-states';

export interface SaleStateBadgeProps {
  state: string;
}

/**
 * Colored badge for a sale's state.
 *
 * @param props.state - The sale state value.
 * @returns The rendered badge.
 */
export function SaleStateBadge({ state }: SaleStateBadgeProps) {
  const label = useSaleStateLabel();
  const style = SALE_STATE_STYLES[state as SaleState] ?? SALE_STATE_STYLES.in_paperwork;

  return (
    <Text
      component="span"
      data-testid="sale-state-badge"
      className="inline-flex items-center px-(--space-2) py-(--space-0-5) rounded-full text-xs font-semibold whitespace-nowrap"
      style={{ background: style.bg, color: style.color }}
    >
      {label(state)}
    </Text>
  );
}

export default SaleStateBadge;
